'use strict';

import MainView from '../views/Main';
import ProfileView from '../views/Profile';
import BaseRouter from 'commons/routers/Base';
import CommonPersonalSettingsView from 'commons/views/PersonalSettings';
import CustomerSupportView from 'commons/views/CustomerSupportForm';
import RolePersonalSettingsView from '../views/PersonalSettings.js';
import DashboardRouter from './Dashboard';
import PayslipsRouter from './Payslips';
import CalendarRouter from './Calendar';

module.exports = BaseRouter.extend({
    routes: {
        'profile':          'profile',
        'personalSettings': 'personalSettings',
        'customerSupport': 'customerSupport'
    },

    titles: {
        'profile':          'Profile',
        'personalSettings': 'Personal Settings',
        'customerSupport': 'Contact Support'
    },

    initialize: function() {
        this.mainView = new MainView();
        if (app.company.get('updateRestricted')) {
            $('#update-restricted-notification').css({display: 'block'});
        }

        this.subRouters = [
            new DashboardRouter({el: this.mainView.childEl}),
            new PayslipsRouter({el: this.mainView.childEl}),
            new CalendarRouter({el: this.mainView.childEl})
        ];

        Backbone.history.on('route', function() {
            this.mainView.setActiveLink(Backbone.history.getFragment());
            window.scrollTo(0, 0);
        }.bind(this));

        $(window).trigger('resize');
        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();
            if (scroll >= 185) {
                $('.ibox-help').addClass('fixed');
            } else {
                $('.ibox-help').removeClass('fixed');
            }
        });
    },

    profile: function() {
        this.undelegateEvents();
        this.view = new ProfileView({
            el: this.mainView.childEl
        });
    },

    personalSettings: function() {
        this.undelegateEvents();

        this.view = new CommonPersonalSettingsView({
            el: this.mainView.childEl,
            model: app.user,
            subViews: [
                new RolePersonalSettingsView({model: app.user})
            ]
        });
    },

    customerSupport: function() {
        this.undelegateEvents();

        this.view = new CustomerSupportView({
            el: this.mainView.childEl,
            model: app.user,
        });
    },

    notFound: function() {
        window.location.replace('/#dashboard');
    }
});



// WEBPACK FOOTER //
// ./app/employee/routers/Main.js